import SVGS from "../../atoms/svgs";
import "./styles.scss";

interface TestimonialProps {
  testimonial: {
    name: string;
    city: string;
    text: string;
    src: string;
    claim?: string;
  };
  starRate?: number;
  avatar?: boolean;
  nameOnBottom?: boolean;
  claim?: boolean;
}

const Testimonial = ({ testimonial, starRate, avatar, nameOnBottom, claim }: TestimonialProps) => {
  const StarIcon = SVGS["star"];

  return (
    <div className="Testimonial u-box">
      {starRate &&
        [...Array(starRate)].map((e, i) => (
          <StarIcon
            key={i}
            className="Testimonial__star"
          />
        ))}
      {avatar && !claim && (
        <div className="Testimonial__avatar">
          <img
            src={testimonial.src}
            alt={testimonial.name}
          />
        </div>
      )}
      {claim && (
        <div className="Testimonial__avatar-claim-wrapper">
          <div className="Testimonial__avatar">
            <img
              src={testimonial.src}
              alt={testimonial.name}
            />
          </div>
          <p className="Testimonial__claim">{testimonial.claim}</p>
        </div>
      )}
      <p className="Testimonial__text">"{testimonial.text}"</p>
      {nameOnBottom ? (
        <div className="Testimonial__details">
          {testimonial.name} -<b> {testimonial.city}</b>
        </div>
      ) : (
        <>
          <div className="Testimonial__name">{testimonial.name}</div>
          <p className="Testimonial__state">{testimonial.city}</p>
        </>
      )}
    </div>
  );
};

export default Testimonial;
